import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeQuery } from '../../../../graphql/queries/account';
import { AlbumData } from '../../../../graphql/queries/albums';
import { photosUpload } from '../../../../graphql/mutations/photos';
import { albumAddPhotos } from '../../../../graphql/mutations/albums';
import ExternalAlbumUpload from '../../../../components/product/ExternalAlbumUpload';
import {
  albumUpload,
  albumUploadReset,
} from '../../../../actions/album-upload';

const withUserData = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
});

const withAlbumData = graphql(AlbumData, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const withPhotosUpload = graphql(photosUpload, {
  props: ({ mutate, ownProps }) => ({
    photosUploadMutation: (accountId, files) =>
      mutate({
        variables: {
          input: {
            account_id: accountId,
            files,
            face_recognition_disabled:
              ownProps.album?.root_album_folder?.face_recognition_disabled,
          },
        },
      }),
  }),
});

const withAlbumAddPhotos = graphql(albumAddPhotos, {
  props: ({ mutate }) => ({
    albumAddPhotosMutation: (albumId, photoIds) =>
      mutate({
        variables: {
          input: {
            album_id: albumId,
            photo_ids: photoIds,
            is_external_upload: true,
          },
        },
      }),
  }),
});

const mapStateToProps = ({ albumUploads }) => ({
  total: albumUploads.total,
  current: albumUploads.current,
  error: albumUploads.error,
  success: albumUploads.success,
  uploading: albumUploads.uploading,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  albumUploadReset: () => dispatch(albumUploadReset()),
  albumUpload: async photos => {
    await albumUpload(
      ownProps.user.id,
      ownProps.match.params.albumId,
      photos,
      dispatch,
      ownProps.photosUploadMutation,
      ownProps.albumAddPhotosMutation,
    );
  },
});

export default compose(
  withUserData,
  withAlbumData,
  withPhotosUpload,
  withAlbumAddPhotos,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(ExternalAlbumUpload);
